import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Input} from 'antd'

@inject('store') @observer
class Password extends Component {
  handleOk = () => {
    const {passwordChange} = this.props.store.user
    if (passwordChange.validate()) {
      passwordChange.submit()
    }
  }
  handleCancel = () => {
    const {passwordChange} = this.props.store.user
    passwordChange.blank()
    this.props.close()
  }
  handleChange = (e) => {
    const {name, value} = e.target
    const {passwordChange} = this.props.store.user
    passwordChange.change(name, value)
  }
  render() {
    const {data, errors, loading} = this.props.store.user.passwordChange
    return(
      <Modal
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
        confirmLoading={loading}
      >
        <Form>
          <Form.Item
            label='New password'
            validateStatus={errors.new_password ? 'error' : null}
            help={errors.new_password}
          >
            <Input
              size='large'
              type='password'
              name='new_password'
              value={data.new_password}
              onChange={this.handleChange}
            />
          </Form.Item>
          <Form.Item
            label='Repeat new password'
            validateStatus={errors.new_password_repeat ? 'error' : null}
            help={errors.new_password_repeat}
          >
            <Input
              size='large'
              type='password'
              name='new_password_repeat'
              value={data.new_password_repeat}
              onChange={this.handleChange}
            />
          </Form.Item>
          <Form.Item
            label='Current password'
            validateStatus={errors.current_password ? 'error' : null}
            help={errors.current_password}
          >
            <Input
              size='large'
              type='password'
              name='current_password'
              value={data.current_password}
              onChange={this.handleChange}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Password
